import {StyleSheet} from "react-native";
import {styleVars} from "../../app-style-vars";

export default StyleSheet.create({
  langSelectorContainer: {
    paddingHorizontal: styleVars.rem(1)
  },
  langSelectorHeaderWrapper: {
    flexDirection:'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  langSelectorHeaderText: {
    fontSize: styleVars.rem(1.25),
    fontWeight: 'bold'
  },
  langSelectorDetailsContainer: {
    paddingTop: 4,
  },
  langSelectorSelectItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.25),
  },
  langSelectorItemActive: {
    backgroundColor: styleVars.boschLightGrayW75
  },
  langSelectorItemDisabled: {
    backgroundColor: styleVars.boschLightGray,
  },

  langSelectorItemName: {
    paddingHorizontal: styleVars.rem(.5)
  },
  langSelectorItemCode: {
    paddingHorizontal: styleVars.rem(.5),
    textAlign: 'right'
  },
  itemTextDisabled: {
    color: styleVars.boschLightGrayW75,
  },
  noAuthText: {
    padding: styleVars.rem(.25),
    textAlign: 'center',
    fontSize: styleVars.rem(.625),
  }
})